"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const pushBlockContainerInputs = [
  {
    name: "carouselDesktop",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Carousel desktop",
    helperText: "Force the container to be displayed as a carousel",
  },
  {
    name: "tabletItemCount",
    type: "number",
    defaultValue: 3,
    friendlyName: "Tablet Item Count",
    helperText: "Number of items to show in the carousel on tablet devices",
  },
  {
    name: "desktopItemCount",
    type: "number",
    defaultValue: 4,
    friendlyName: "Desktop Item Count",
    helperText: "Number of items to show in the carousel on desktop devices",
  },
  {
    name: "isAutoHeight",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const PushBlockContainerComponent: RegisteredComponent = {
  name: "PushBlockContainer",
  component: dynamic(async () => (await import("./PushBlockContainer")).PushBlockContainer),
  inputs: pushBlockContainerInputs,
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  childRequirements: {
    message: "You can only put PushBlock inside this component",
    query: {
      "component.name": {
        $in: ["PushBlock"],
      },
    },
  },
};
